import React, { useEffect, useState } from 'react';
import ResultLink from '../../components/ResultLink';
import { unitConversion, sortResultsByDistance } from '../../helpers';

const NearbyCommunitiesColumnList = props => {
  const { controller, maxResults, distanceLabel, coveoUnit = 'mi' } = props;
  const [state, setState] = useState(controller.state);
  const [displayedResults, setDisplayedResults] = useState([]);

  useEffect(() => {
    controller.subscribe(() => {
      setState(controller.state);
      const originalResults = [...controller.state.results];
      const sortedResults = sortResultsByDistance(originalResults);
      setDisplayedResults(sortedResults);
    });
  }, []);

  return (
    <>
      <ul className="nearby-communities-supporting-column-headless__featured">
        {state &&
          displayedResults.length > 0 &&
          displayedResults.slice(0, maxResults).map((result, index) => (
            <li key={index}>
              <ResultLink
                result={result}
                className="nearby-communities-supporting-column-headless__community"
              >
                <div className="nearby-communities-supporting-column-headless__image">
                  <span>
                    <img
                      src={
                        result.raw.ssl_thumbnailimage ||
                        result.raw.ssl_mainimagedesktop
                      }
                      alt={result.raw.title}
                    />
                  </span>
                </div>
                <div className="nearby-communities-supporting-column-headless__info">
                  <span className="nearby-communities-supporting-column-headless__title">
                    {result.raw.ssl_communityname
                      ? result.raw.ssl_communityname
                      : result.raw.ssl_heading}
                  </span>
                  <span className="nearby-communities-supporting-column-headless__distance">
                    <span>
                      {unitConversion(result.raw.distance, coveoUnit)}{' '}
                      {distanceLabel}
                    </span>
                  </span>
                </div>
              </ResultLink>
            </li>
          ))}
      </ul>
    </>
  );
};

export default NearbyCommunitiesColumnList;
